import { Injectable } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  AddAddressErrorMessages,
  AddAddressFormAttributes,
  AddAddressPageContent,
  ErrorMessage
} from '@com-delta-idp/mnx-login-ui';

import {
  addressLine1,
  city,
  state,
  zipCode
} from '../../../validator/add-address-validator';
import {
  AddressLinesResponse,
  CountryListResponse
} from '../../models/add-address.interface';
import { LoginModalContent } from '../../models/aem';
import { AddAddressHelperSupportService } from './add-address-helper-support.service';

@Injectable({
  providedIn: 'root'
})
export class AddAddressHelperService extends AddAddressHelperSupportService {
  form!: UntypedFormGroup;
  constructor(
    private adddAddresshelpersupportservice: AddAddressHelperSupportService
  ) {
    super();
  }

  createForm(): UntypedFormGroup {
    this.form = new UntypedFormGroup({
      country: new UntypedFormControl(null),
      addressLine1: new UntypedFormControl(null, [
        Validators.required,
        addressLine1
      ]),
      addressLine2: new UntypedFormControl(null),
      district: new UntypedFormControl(null),
      city: new UntypedFormControl(null, [Validators.required, city]),
      addressLine6: new UntypedFormControl(null),
      state: new UntypedFormControl(null, [Validators.required, state]),
      postalCode: new UntypedFormControl(null, [Validators.required, zipCode])
    });
    return this.form;
  }

  getFormGroup(): UntypedFormGroup {
    return this.form;
  }

  getPageContent({
    ...unTransformedData
  }: {
    aemResponse: LoginModalContent;
    countryCodes: CountryListResponse;
    addressLines: AddressLinesResponse;
  }): AddAddressPageContent {
    const {
      aemResponse: { addAddress, pageHeader },
      countryCodes,
      addressLines
    } = unTransformedData;
    return {
      ...addAddress,
      countryList: this.transformCountryCodes(
        countryCodes.countryCodeList,
        addAddress.defaultValueCountry
      ),
      addressFields: this.transformAddressLines(addressLines),
      stateList: this.stateList,
      stateLabel: this.stateLabel,
      defaultStateSelectValue: addAddress.defaultValueState,
      defaultCountrySelectValue: addAddress.defaultValueCountry,
      pageHeader: {
        ...pageHeader,
        headerTitle: addAddress.headerTitle,
        headerSubTitle: addAddress.headerSubTitle,
        contentBodyHeader: addAddress.contentBodyHeader
      },
      buttonLabel: addAddress.nextDisplayView.button_modal,
      errors: this.getInitialErrorMessage(unTransformedData.aemResponse)
    };
  }

  getFormAttributes(): AddAddressFormAttributes {
    return {
      errorCount: 0,
      submitAttempt: false,
      errorAlertBanner: false,
      disableActionButton: false,
      addressLine1ControlTouched: false,
      addressLine2ControlTouched: false,
      districtControlTouched: false,
      stateControlTouched: false,
      countryControlTouched: false,
      addressLine6ControlTouched: false,
      cityControlTouched: false,
      postalCodeControlTouched: false
    };
  }

  getInitialErrorMessage(
    aemResponse: LoginModalContent
  ): AddAddressErrorMessages {
    const errorMessages: AddAddressErrorMessages = {
      addressLine1ErrorMessage: {
        INVALID_ADDR_LINE_1: '',
        ADDR_WITH_NO_LETTERS: ''
      },
      addressLine2ErrorMessage: {
        INVALID_ADDR_LINE_2: ''
      },
      districtErrorMessage: {
        INVALID_DISTRICT: ''
      },
      cityErrorMessage: {
        INVALID_CITY: ''
      },
      stateErrorMessage: {
        SELECT_STATE: '',
        SELECT_PREFECTURE: ''
      },
      postalCodeErrorMessage: {
        INVALID_ZIP_CODE: ''
      },
      alertWarning: 'To continue, please correct the'
    };
    aemResponse.errors.errorMessages.forEach((option: ErrorMessage) => {
      this.initialErrorMessage(option, errorMessages);
    });
    return errorMessages;
  }
}
